<menu>
    <div class="container">
        <nav>
            <ul>
                <li>
                    <a routerLink="/mypolls" class="logo-header" >wb.form</a>
                </li>
                <ng-container *ngIf="auth.isLoggedIn">
                    <li class="nav" *ngIf="auth.roleMatch(['superadmin', 'creator', 'admin'])">
                        <a routerLink="/mypolls" routerLinkActive="active" [routerLinkActiveOptions]="{exact:
                            true}" href="">Вопросы</a>
                        <a *ngIf="poll_id !== '-1'" routerLinkActive="active" [routerLinkActiveOptions]="{exact:
                            true}" [routerLink]="['answers', poll_id]" href="">Ответы</a>
                        <a routerLink="/admin" routerLinkActive="active">Admin panel</a>
                    </li>
                </ng-container>
                <ng-container *ngIf="auth.isLoggedIn; then profile else signIn"></ng-container>
                <ng-template #profile>
                    <li class="profile">
                        <a routerLink="/profile" routerLinkActive="active" >
                            <i class="fas fa-user-alt"></i>
                            Профиль
                        </a>
                    </li>
                </ng-template>
                <ng-template #signIn>
                    <li class="sign-in"><button mat-raised-button  (click)="openLogin()">Войти</button></li>
                </ng-template>
            </ul>
        </nav>
    </div>
</menu>